define(function (require) {
    const tpl = require('civicsViews/share_email_view/templates/t_lov_share_url_modal.hbs');
    const url_itv = require('civicsViews/share_email_view/v_itv_url');

    const ViewManager = require('civicsUtils/view_manager');

    return Marionette.LayoutView.extend({
        template: tpl,
        ui: {
            shareUrlModal: '.bbm-modal.share-url-modal',
            shareUrlModalContainer: '.share-url-modal-container',
            sendContent: '.send-content',
            urlItem: '.url-item',
            urlReceipientContent: '.url-recipient-content',
            cancelButton: '.cancel-button',
        },
        events: {
            'click @ui.cancelButton': 'closeEmailModal',
            'click .bbm-btn-close': 'closeEmailModal'
        },
        regions: {
            urlRegion: "@ui.urlItem",
        },
        initialize: function (options) {
            this.config = options.config;
            this.modalRegion = options.modalRegion; // reuse modalRegion from the parent view
            this.URLPath = options.URLPath;
            this.URLParams = options.URLParams;
            this.usesFullURLPath = options.usesFullURLPath;
            this.translationPath = options.translationPath;
            var trPath = this.translationPath.toUpperCase();
            this.commonLabel = {
    					copyUrlDescription:`CIVICS.${trPath}.SHARE_MODAL.COPY_URL_DESCRIPTION`,
    					sendEmail: `CIVICS.${trPath}.SHARE_MODAL.EMAIL_LINK`,
    					copyLink: `CIVICS.${trPath}.SHARE_MODAL.COPY_LINK`,
    					copiedLink: `CIVICS.${trPath}.SHARE_MODAL.COPIED_LINK`,
    					urlField: `CIVICS.${trPath}.SHARE_MODAL.URL_FIELD`,
    					emailBody: `CIVICS.${trPath}.SHARE_MODAL.BODY`,
    					emailSubject: `CIVICS.${trPath}.SHARE_MODAL.SUBJECT`
    				};
        },
        onRender: function () {
            this.ui.sendContent.detach().prependTo(this.ui.shareUrlModal);

            this.urlItemView = new url_itv({
                config: this.config,
                URLPath: this.URLPath,
                commonLabel: this.commonLabel
            });

        },
        onShow: function () {
            this.urlRegion.show(this.urlItemView);
        },
        closeEmailModal: function () {
            if (this.modalRegion) {
                this.modalRegion.hideModal();
            } else {
                this.destroy();
            }
        },
        templateHelpers: function () {
            var self = this;
            return {
                copyUrlDescription: i18n.t(self.commonLabel.copyUrlDescription),
            };
        }
    });
});
